import block from './block.json';

export const cardPeopleThemeAttributes = {
	backgroundColor: '@tokens.variants.default.cardBackgroundColor',
	border: {
		color: '@tokens.variants.default.cardBorderColor',
		width: {
			top: [0, 0],
			right: [0, 0],
			bottom: [0, 0],
			left: [0, 0],
		},
		radius: {
			topLeft: [0, 0],
			topRight: [0, 0],
			bottomRight: [0, 0],
			bottomLeft: [0, 0],
		},
	},
	direction: 'row',
	minWidth: '200px',
	maxWidth: '320px',
	padding: {
		top: [10, 20],
		right: [10, 20],
		bottom: [10, 20],
		left: [10, 20],
	},
	image: {
		width: [88, 125],
		height: [88, 125],
		margin: {
			top: [0, 0],
			right: [0, 0],
			bottom: [0, 0],
			left: [0, 0],
		},
		border: {
			color: '@tokens.variants.default.cardBorderColor',
			width: {
				top: [0, 0],
				right: [0, 0],
				bottom: [0, 0],
				left: [0, 0],
			},
			radius: {
				topLeft: [0, 0],
				topRight: [0, 0],
				bottomRight: [0, 0],
				bottomLeft: [0, 0],
			},
		},
	},
	title: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
	role: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
	},
	link: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.links',
		textAlignment: 'left',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardPeopleThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardPeopleThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
